import { Store } from "../stores/Store";
import { SessionStore } from "../uidispatcherapi/SessionStore";

import { getPriceConfig } from "../clients/PriceConfigClient";

import { PriceConfig } from "../types/articlesearch/Price";

export const STATES = {
    EMPTY: 0,
    LOADING: 1,
    LOADED: 2,
    ERROR: 3,
    MODIFIED: 4
};

const emptyConfig = {
    priceBreakdown: {
        primaryPriceType: "net" as const,
        includeMarginTaxesInPrice: false
    },
    priceCompact: {
        primary: "unitNet",
        secondary: "unitGross"
    }
};

export class PriceConfigStoreImpl extends Store {
    // initialized in _resetState
    loadedConfig!: PriceConfig;
    state!: number;

    constructor() {
        super();
        this._resetState();
        this.loadConfig();
    }

    _resetState() {
        this.loadedConfig = emptyConfig;
        this.state = STATES.EMPTY;
    }

    loadConfig() {
        if (this.state !== STATES.EMPTY && this.state !== STATES.ERROR) {
            return;
        }
        this.state = STATES.LOADING;
        const country = SessionStore.getCountry();
        getPriceConfig(country).then(this.doCompleted).catch(this.doFailed);
    }

    getConfig(): PriceConfig {
        return this.loadedConfig;
    }

    doCompleted = (response: PriceConfig | undefined | null) => {
        this.state = STATES.LOADED;
        if (response) {
            this.setConfigState(response);
        } else {
            this.clearConfigState();
        }
    };

    doFailed = (error: any) => {
        this.state = STATES.ERROR;
        this.clearConfigState();
        console.warn("Failed to get price display configuration.", error);
    };

    clearConfigState() {
        this.loadedConfig = emptyConfig;
        this.trigger(this.loadedConfig);
    }

    setConfigState(config: PriceConfig) {
        this.loadedConfig = config;
        this.trigger(config);
    }

    getInitialState(): {
        priceConfig: PriceConfig;
        state: number;
    } {
        return { priceConfig: this.loadedConfig, state: this.state };
    }
}

export const PriceConfigStore = new PriceConfigStoreImpl();
